import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { css } from "styled-components";
import { getThemeData, createStyleComponent } from "@hzero-front-ui/core";
function getSelectBoxStyle(props) {
  var d = getThemeData(props, "input");
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .c7n-pro-select-box-wrapper,\n    .c7n-pro-select-box {\n      height: ", "px;\n    }\n  "])), d.inputHeight);
}
var SelectBox = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  /* SelectBox--pro \u5168\u5C40\u6837\u5F0F\u5B9E\u73B0 */\n  ", "\n"])), getSelectBoxStyle);
export default createStyleComponent("selectBox", SelectBox);